import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 4c0-.55-.45-1-1-1s-1 .45-1 1H8c0-.55-.45-1-1-1s-1 .45-1 1H4.01C2.9 4 2 4.9 2 6.01v12.98C2 20.1 2.9 21 4.01 21h15.98c1.11 0 2.01-.9 2.01-2.01V6.01C22 4.9 21.1 4 19.99 4zM7 7c-.547 0-.995-.445-1-.99H4.01V8H20V6.01h-2c-.006.545-.453.99-1 .99s-.994-.445-1-.99H8c-.005.545-.453.99-1 .99m-2.99 3H20v8.99H4.01z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendar;
